module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-13.efcc6b92.svg";